/** @type {import('tailwindcss').Config} */

const plugin = require('tailwindcss/plugin');

module.exports = {
  darkMode: 'class',
  content: ['./pages/**/*.{js,ts,jsx,tsx}', './components/**/*.{js,ts,jsx,tsx}'],
  theme: {
    screens: {
      sm: '310px',
      md: '672px',
      lg: '1400px',
    },
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      white: '#FFFFFF',
      black: '#000000',
      dark: '#363636',
      functional: {
        1: '#FFFFFF',
        2: '#FCFCFC',
        3: '#F2F2F2',
        4: '#EAEAEA',
        5: '#B0B0B0',
        6: '#8C8C8C',
        7: '#434343',
        8: '#363636',
        9: '#000000',
      },
      primary: {
        DEFAULT: '#3763FF',
        1: '#3763FF',
        lighter: '#D3DDFF',
        2: '#D3DDFF',
        lightest: '#F0F4FF',
        3: '#F0F4FF',
        lightestMore: '#F6F8FD',
        4: '#F6F8FD',
        dark: '#2525D7',
        5: '#2525D7',
        light: '#4D74FF',
        6: '#4D74FF',
      },
      secondary: {
        brick: '#BC6038',
        tan: '#D0AE86',
        sand: '#F2D6BB',
        yellow: '#EFAC26',
        red: '#F3683C',
        green: '#29A964',
      },
    },
    fontSize: {
      xs: '.75rem',
      sm: '16px',
      tiny: '.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '4rem',
      '7xl': '5rem',
    },
    extend: {
      fontFamily: {
        display: ['Space Grotesk, sans-serif'],
        regular: ['Archivo, sans-serif'],
        mono: ['Fira Code, sans-serif'],
      },
      boxShadow: {
        btn: 'inset 0 0 0 3px',
      },
      borderWidth: {
        3: '3px',
      },
      backgroundSize: {
        'size-200': '200% 200%',
      },
      backgroundPosition: {
        'pos-0': '0% 0%',
        'pos-100': '100% 100%',
      },
      animation: {
        'gradient-x': 'gradient-x 1s ease infinite',
        'gradient-y': 'gradient-y 1s ease infinite',
      },
      keyframes: {
        'gradient-y': {
          '0%, 100%': {
            'background-size': '400% 400%',
            'background-position': 'center top',
          },
          '50%': {
            'background-size': '200% 200%',
            'background-position': 'center center',
          },
        },
        'gradient-x': {
          '0%, 100%': {
            'background-size': '200% 200%',
            'background-position': 'left center',
          },
          '50%': {
            'background-size': '200% 200%',
            'background-position': 'right center',
          },
        },
      },
    },
  },
  plugins: [
    require('@tailwindcss/forms'),
    plugin(function ({ addComponents, theme }) {
      addComponents({
        '.flex-center': {
          display: 'flex',
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'center',
        },
        '.shade': {
          boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.05)',
        },
        '.shade-side': {
          boxShadow: '-2px 0 20px 0 rgba(0, 0, 0, 0.05)',
        },
      });
    }),
    // ...
  ],
};
